import { mapGetters, mapActions } from "vuex";
import { getGlobalSearchFund, getGlobalSearchStock, getGlobalSearchIndice } from "./global-search-filter";

export default {
  data() {
    return {
      mixins_global_search_searchResults: {
        fund: [],
        stock: [],
        indice: [],
      },
      mixins_global_search_allTab_notFound: false,
      mixins_global_search_scoreResults: {
        stock: 0,
        fund: 0,
        indice: 0
      },
      mixins_global_search_orderSearchScore: {
        stock: "order-0",
        fund: "order-0",
        indice: "order-0",
      },
      mixins_global_search_historyList: []
    }
  },
  computed: {
    ...mapGetters("fund", ["getFundList"]),
    ...mapGetters("stock", ["getStockList"]),
    ...mapGetters("indice", ["getIndiceList"])
  },
  created() {
    const stockList = this.getStockList;
    const fundList = this.getFundList;
    const indiceList = this.getIndiceList
    
    this.getDataFundAndStock(stockList, fundList, indiceList);
  },
  methods: {
    ...mapActions("fund", ["findFundList"]),
    ...mapActions("stock", ["findStockList"]),
    ...mapActions("indice", ["findIndiceList"]),

    async getDataFundAndStock(stockList, fundList, indiceList) {
      if (stockList) {
        this.findStockList();
      }
      if (fundList) {
        this.findFundList();
      }
      if (indiceList) {
        this.findIndiceList();
      }
    },

    async mixins_global_search_getSearchAllFunction(searchKeyword) {
      this.mixins_global_search_allTab_notFound = false
      this.mixins_global_search_getSearchFundFunction(searchKeyword)
      this.mixins_global_search_getSearchStockFunction(searchKeyword)
      this.mixins_global_search_getSearchIndiceFunction(searchKeyword)
      await this.orderBySearchScore()
      if (this.mixins_global_search_searchResults.fund.length === 0 &&
        this.mixins_global_search_searchResults.stock.length === 0 &&
        this.mixins_global_search_searchResults.indice.length === 0) {
        this.mixins_global_search_allTab_notFound = true
      }
    },

    mixins_global_search_getSearchFundFunction(searchKeyword) {
      const fundList = this.getFundList;
      const fundSearchResults = getGlobalSearchFund(
        fundList,
        searchKeyword
      );
      this.mixins_global_search_searchResults.fund = fundSearchResults.data;
      this.mixins_global_search_scoreResults.fund = fundSearchResults.score;
    },

    mixins_global_search_getSearchStockFunction(searchKeyword) {
      const stockList = this.getStockList;
      const stockSearchResults = getGlobalSearchStock(
        stockList,
        searchKeyword
      );
      this.mixins_global_search_searchResults.stock = stockSearchResults.data;
      this.mixins_global_search_scoreResults.stock = stockSearchResults.score;
    },

    mixins_global_search_getSearchIndiceFunction(searchKeyword) {
      const indiceList = this.getIndiceList;
      const indiceSearchResults = getGlobalSearchIndice(
        indiceList,
        searchKeyword
      );
      this.mixins_global_search_searchResults.indice = indiceSearchResults.data;
      this.mixins_global_search_scoreResults.indice = indiceSearchResults.score;
    },

    async orderBySearchScore() {
      let sortScore = [];
      for (let score in this.mixins_global_search_scoreResults) {
        await sortScore.push([score, this.mixins_global_search_scoreResults[score]]);
      }
      sortScore.sort(function (scoreA, scoreB) {
        return scoreA[1] - scoreB[1];
      });
      sortScore.map((item, index) => {
        this.mixins_global_search_orderSearchScore[item[0]] = "order-" + index;
      });
    },

  }
}
